(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('ObjectTestSettingDialogController', ObjectTestSettingDialogController);

    ObjectTestSettingDialogController.$inject = ['Profile_User','$timeout', '$scope', '$state', 'entity', 'ObjectTestSetting', 'TabObjectTypes', 'AlertService', 'ParseLinks', 'TabFleets', 'TestSettingTag', '$uibModal'];

    function ObjectTestSettingDialogController(Profile_User, $timeout, $scope, $state, entity, ObjectTestSetting, TabObjectTypes, AlertService, ParseLinks, TabFleets, TestSettingTag, $uibModal) {
        var vm = this;

        vm.objectTestSetting = entity;
        vm.tabObjectTypes = [];
        vm.tabFleets = [];
        vm.testsTag = [];
        vm.testsTag2 = [];
        vm.userProfiles = ["Tech","test","ADMIN","OPERATOR","TECH","test"];
        vm.metric = [];
        vm.valueToCheck=null;
        vm.tempMetric = null;
        vm.tempSecondaryMetric = null;
        vm.hasInteractedWithSecondaryMetric = false;
        vm.timeSpan = {};
        vm.periodUnit = ["Seconds","Minutes", "Hours"];
        vm.page = 0;
        vm.save = save;
        vm.clear = clear;
        vm.checkAggregationAllowed = checkAggregationAllowed;

        if (vm.objectTestSetting.checkType && vm.objectTestSetting.checkType === 'Between') {
            var values = vm.objectTestSetting.expectedValue.split(',');
            vm.expectedA = parseInt(values[0]);
            vm.expectedB = parseInt(values[1]);
        } else if (vm.objectTestSetting.checkType && (vm.objectTestSetting.checkType === 'Equals' || vm.objectTestSetting.checkType === 'Not Equals')) {
            vm.expected = vm.objectTestSetting.expectedValue;
        } else {
            vm.expectedNumber = parseInt(vm.objectTestSetting.expectedValue);
        }

        if(vm.objectTestSetting.valueToCheck) {
            vm.valueToCheck = vm.objectTestSetting.valueToCheck;
        }

        TestSettingTag.byDomain({size: 1000}, function (result) {
            vm.testsTag = result;
        })

        if(vm.objectTestSetting.timeSpan) {
            if(vm.objectTestSetting.timeSpan === 'Last value') {
                vm.timeSpan.time = vm.objectTestSetting.timeSpan;
            } else {
                if (vm.objectTestSetting.timeSpan.endsWith('s')) {
                    vm.timeSpan.time = "Seconds";
                } else if (vm.objectTestSetting.timeSpan.endsWith('m')) {
                    vm.timeSpan.time = "Minutes";
                } else {
                    vm.timeSpan.time = "Hours";
                }
                vm.timeSpan.period = parseInt(vm.objectTestSetting.timeSpan.substring(0, vm.objectTestSetting.timeSpan.length - 1));
            }
            checkAggregationAllowed();
        }
        vm.checkTypes = ObjectTestSetting.checkType();

        vm.aggregations = ObjectTestSetting.aggregations();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go('object-test-setting');
        }

        function save() {
            vm.isSaving = true;

            // clearance secondary metric
            if(!vm.hasInteractedWithSecondaryMetric) {
                vm.objectTestSetting.secondaryMetric = null;
                vm.objectTestSetting.secondaryMetricExpectedValue = null;
            }

            // if(!vm.objectTestSetting.manual && vm.objectTestSetting.metric.indexOf("properties") > -1 && vm.objectTestSetting.metric.indexOf("keyword") < 0) {
            //     vm.objectTestSetting.metric = vm.objectTestSetting.metric + ".keyword";
            // }
            if (!vm.objectTestSetting.manual && ((vm.objectTestSetting.checkType !== 'Between' && vm.objectTestSetting.checkType !== 'Exists' && vm.objectTestSetting.checkType !== 'Not Exists' &&
                    (((vm.objectTestSetting.checkType === 'Equals' || vm.objectTestSetting.checkType === 'Not Equals') && (vm.expected.length === 0 || angular.isUndefined(vm.expected))) ||
                        ((vm.objectTestSetting.checkType !== 'Equals' && vm.objectTestSetting.checkType !== 'Not Equals') && (vm.expectedNumber === null || angular.isUndefined(vm.expectedNumber )))))
                || (vm.objectTestSetting.checkType === 'Between' && (angular.isUndefined(vm.expectedA) || angular.isUndefined(vm.expectedB))))) {
                AlertService.error("Insert expected value");
                vm.isSaving = false; // reset saving state
            } else {
                if(!vm.objectTestSetting.manual) {
                    if (vm.objectTestSetting.checkType === 'Between') {
                        vm.objectTestSetting.expectedValue = vm.expectedA + "," + vm.expectedB;
                    } else if (vm.objectTestSetting.checkType === 'Equals' || vm.objectTestSetting.checkType === 'Not Equals') {
                        vm.objectTestSetting.expectedValue = vm.expected;
                    } else {
                        vm.objectTestSetting.expectedValue = vm.expectedNumber;
                    }
                    if(vm.valueToCheck !== null) {
                        vm.objectTestSetting.valueToCheck = vm.valueToCheck;
                    }
                    if(vm.timeSpan.time === 'Last value') {
                        vm.objectTestSetting.timeSpan = vm.timeSpan.time;
                    } else {
                        if(vm.timeSpan.period === undefined || vm.timeSpan.period === null || vm.timeSpan.period === "") {
                            AlertService.error("Insert Period");
                            vm.isSaving = false;
                            return;
                        } else if (vm.timeSpan.time === "Seconds") {
                            vm.objectTestSetting.timeSpan = vm.timeSpan.period + "s";
                        } else if (vm.timeSpan.time === "Minutes") {
                            vm.objectTestSetting.timeSpan = vm.timeSpan.period + "m";
                        } else {
                            vm.objectTestSetting.timeSpan = vm.timeSpan.period + "h";
                        }
                    }
                } else {
                    vm.objectTestSetting.checkType = "Manual";
                    vm.objectTestSetting.aggregation = "None";
                    vm.objectTestSetting.metric = "";
                    vm.objectTestSetting.timeSpan="";
                    vm.objectTestSetting.expectedValue = "";
                }
                if(vm.objectTestSetting.checkType === 'Exists' || vm.objectTestSetting.checkType === 'Not Exists') {
                    vm.objectTestSetting.expectedValue = null;
                }
                if (vm.objectTestSetting.id !== null) {
                    ObjectTestSetting.update(vm.objectTestSetting, onSaveSuccess, onSaveError);
                } else {
                    ObjectTestSetting.save(vm.objectTestSetting, onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('jotApp:objectTestSettingUpdate', result);
            vm.isSaving = false;
            $state.go('object-test-setting');
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function checkAggregationAllowed() {
            if (vm.objectTestSetting.checkType === 'Exists' || vm.objectTestSetting.checkType === 'Not Exists') {
                vm.objectTestSetting.aggregation = 'None';
                vm.aggregationDisabled = true;
            } else {
                vm.aggregationDisabled = false;
            }

            if (vm.objectTestSetting.checkType === 'Exists' || vm.objectTestSetting.checkType === 'Not Exists' ||
                vm.objectTestSetting.checkType === 'Equals' || vm.objectTestSetting.checkType === 'Not Equals') {
                if(vm.periodUnit.indexOf("Last value") < 0) {
                    vm.periodUnit.push("Last value");
                }
            } else {
                if(vm.periodUnit.indexOf("Last value") > -1) {
                    vm.periodUnit.splice(3, 1);
                }
            }
        }

        vm.loadAllTypes = function () {
            TabObjectTypes.mapped().$promise.then(function (data) {
                var mappedObjectType = JSON.parse(angular.toJson(data));
                vm.tabObjectTypes = mappedObjectType[-1];
            });

            if(vm.objectTestSetting.id != null) {
                var tempM = vm.objectTestSetting.metric;
                var tempSecondaryM = vm.objectTestSetting.secondaryMetric;

                metricLoad();
                vm.tempMetric = {name: tempM};

                if(tempSecondaryM) {
                    vm.tempSecondaryMetric = {name: tempSecondaryM};
                    vm.hasInteractedWithSecondaryMetric = true; // user has not interacted
                }
            }
        };

        vm.loadAllFleets = function () {
            TabFleets.query(onSuccess, onError);

            function onSuccess(data) {
                for (var i = 0; i < data.length; i++) {
                    vm.tabFleets.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.loadUserProfile = function (){
            Profile_User.getUserProfile({ size: 145 }, function (results) {
                vm.testsTag2 = results;
            })
        };

        vm.loadAllTypes();
        vm.loadAllFleets();
        vm.loadUserProfile();

        vm.checkTimePeriod = function () {
            if(vm.timeSpan.time === "Last value"){
                vm.timeSpan.period = "";
            }
        };

        vm.loadMetric = function () {
            metricLoad();
        }

        function metricLoad() {
            vm.metric = [];
            vm.tempMetric = null;
            vm.tempSecondaryMetric = null;
            var body = {id: vm.objectTestSetting.tabObjectTypes.id};

            TabObjectTypes.getMapping(body, onSuccess, onError);

            function onSuccess(data) {
                var obj = data.properties;
                angular.forEach(obj, function (value, key) {
                    var metric = "", app = "";
                    metric += key.toString();
                    if(value.type == undefined){
                        angular.forEach(value.properties, function (value, key) {
                            getProperties(value,key, metric);
                        })
                    } else {
                        vm.metric.push({name: metric});
                    }
                });
            }

            function getProperties(value, key, metric) {
                var subMetric = "";
                subMetric += "." + key.toString();
                if(value.type == undefined){
                    metric += subMetric;
                    angular.forEach(value.properties, function (value, key) {
                        getProperties(value,key,metric);
                    })
                } else {
                    vm.metric.push({name: metric+subMetric});
                }
            }

            function onError(){
                AlertService.error("Mapping not Available");
            }
        }

        vm.loadUserProfilePage = function (page) {
            if (page <= vm.userProfileLinks['last']) {
                vm.userProfilePage = page;
                vm.loadAll(UserProfile, vm.userProfiles, vm.userProfilePage, vm.userProfileLinks);
            }
        };

        vm.updateMetric = function () {
            vm.objectTestSetting.metric = vm.tempMetric.name;
        }

        vm.updateSecondaryMetric = function () {
            vm.hasInteractedWithSecondaryMetric = true; // user interacted
            if (vm.tempSecondaryMetric && vm.tempSecondaryMetric.name) {
                vm.objectTestSetting.secondaryMetric = vm.tempSecondaryMetric.name;
            } else {
                vm.objectTestSetting.secondaryMetric = null;
                vm.objectTestSetting.secondaryMetricExpectedValue = null;
            }
        }

        vm.newTag = function () {
            $uibModal.open({
                templateUrl: 'app/entities/object-test-setting/new-tag.html',
                controller: 'NewTagController',
                controllerAs: 'vm',
                size: 'md',
            }).result.then(function () {
                $state.reload();
            });
        };
        /*vm.loadUserProfile = function (){
            UserProfile.getUserProfile({ size: 1000 }, function (results) {
                vm.testsTag2 = results;
            });
        };*/
    }
})();
